__webpack_require__.p = "https://dsc-workforce-partners-stg.herokuapp.com/";